// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import image from '@/assets/user.jpg'
import moment from 'moment'
import mdl from 'material-design-lite'
import Vuex from 'vuex'
import createEasyFirestore from 'vuex-easy-firestore'
import VueHtmlToPaper from '@/components/printer'
import VueCurrencyFilter from 'vue-currency-filter'

Vue.config.productionTip = false

Vue.use(mdl)
Vue.use(Vuex)
Vue.use(VueCurrencyFilter,
  {
    symbol: 'Rs',
    thousandsSeparator: ',',
    fractionCount: 2,
    fractionSeparator: '.',
    symbolPosition: 'front',
    symbolSpacing: true
  })

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=no',
    'scrollbars=no'
  ],
  styles: [
    'https://fonts.googleapis.com/icon?family=Material+Icons',
    'https://code.getmdl.io/1.2.1/material.blue-red.min.css'
  ]
}
Vue.use(VueHtmlToPaper, options)

let config = {
  apiKey: 'AIzaSyBqbdlyQZIPF2bGL0WNp-7qNi0kCF_H5rM',
  authDomain: 'testdata-32ade.firebaseapp.com',
  databaseURL: '"https://testdata-32ade.firebaseio.com',
  projectId: 'testdata-32ade',
  storageBucket: 'testdata-32ade.appspot.com',
  messagingSenderId: '816312989969'
}

let firebaseApp = firebase.initializeApp(config)

const settings = {timestampsInSnapshots: true}
const dbinstance = firebaseApp.firestore()
dbinstance.settings(settings)
dbinstance.enablePersistence()
  .catch(function (err) {
    if (err.code === 'failed-precondition') {
      // Multiple tabs open, persistence can only be enabled
      // in one tab at a a time.
      // ...
    } else if (err.code === 'unimplemented') {
      // The current browser does not support all of the
      // features required to enable persistence
      // ...
    }
  })

/* eslint-disable no-new */

const userDataModule = {
  firestorePath: 'users/{userId}',
  firestoreRefType: 'doc', // 'collection' or 'doc'
  moduleName: 'userData',
  statePropName: 'user',
  // you can also add state/getters/mutations/actions
  // for other config like fillables see 'Extra features'
  serverChange: {
    defaultValues: {
      displayName: 'Alice'
    }
  }
}
const companyDataModule = {
  firestorePath: 'companies/{companyId}',
  firestoreRefType: 'doc',
  moduleName: 'companyData',
  statePropName: 'company',
  serverChange: {
    defaultValues: {
      name: 'Alice'
    }
  }
}
const billsDataModule = {
  firestorePath: 'companies/{companyId}/bills',
  firestoreRefType: 'collection',
  moduleName: 'billsData',
  statePropName: 'bills',
  sync: {
    orderBy: ['timestamp', 'desc'],
    whereFilters: ['type', '===', 'PROD']
  },
  serverChange: {
    addedHook: function (updateStore, doc, id, store, source, change) {
      // console.log(doc)
      updateStore(doc)
    },
    modifiedHook: function (updateStore, doc, id, store, source, change) {
      // console.log(doc)
      updateStore(doc)
    },
    removedHook: function (updateStore, doc, id, store, source, change) { updateStore(doc) }
  }
}
const billDataModule = {
  firestorePath: 'companies/{companyId}/bills/{billId}',
  firestoreRefType: 'doc',
  moduleName: 'billData',
  statePropName: 'bill'
  // sync: { // .where('slug', '==', to.params.bill)
  //   whereFilters: ['slug', '===', '{slug}']
  // }
}
const easyFirestore = createEasyFirestore([userDataModule, companyDataModule, billsDataModule, billDataModule], {logging: true})
const store = new Vuex.Store({
  state: {
    userData: {user: {displayName: 'Raavanan'}},
    companyData: {company: {name: 'inception'}}
  },
  mutations: {
    increment (state) {
      state.count++
    }
  },
  plugins: [easyFirestore]
})

let MyApp = {}
MyApp.store = store

Vue.directive('mdl', {
  bind (el) {
    window.componentHandler.upgradeElement(el)
  }
})

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(new Date(value)).format('DD/MM/YYYY hh:mm')
  }
})
Vue.filter('formatSequenceNumber', function (value) {
  if (value) {
    return (('00000' + value).slice(-5)).toString()
  }
})
Vue.filter('uppercase', function (value) {
  if (value) {
    return value.toUpperCase()
  }
})
Vue.filter('titlecase', function (value) {
  if (value) {
    var splitStr = value.toLowerCase().split(' ')
    for (var i = 0; i < splitStr.length; i++) {
      // You do not need to check if i is larger than splitStr length, as your for does that for you
      // Assign it back to the array
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
    }
    // Directly return the joined string
    return splitStr.join(' ')
  }
})

let saveToFirestore = function () {
  let currentUserInfo = {}
  if (firebase.auth().currentUser.displayName) currentUserInfo.displayName = firebase.auth().currentUser.displayName
  if (firebase.auth().currentUser.email) currentUserInfo.email = firebase.auth().currentUser.email
  if (firebase.auth().currentUser.emailVerified) currentUserInfo.emailVerified = firebase.auth().currentUser.emailVerified
  if (firebase.auth().currentUser.phoneNumber) currentUserInfo.phoneNumber = firebase.auth().currentUser.phoneNumber
  if (firebase.auth().currentUser.photoURL) currentUserInfo.photoURL = firebase.auth().currentUser.photoURL
  if (firebase.auth().currentUser.providerData[0].providerId) currentUserInfo.providerId = firebase.auth().currentUser.providerData[0].providerId
  console.log(currentUserInfo)
  firebase.app().firestore().collection('users')
    .doc(firebase.auth().currentUser.uid).set(currentUserInfo, { merge: true })
    .then(function () {
      console.log('saveToFirestore Document successfully written!')
    })
    .catch(function (error) {
      console.error('saveToFirestore Error writing document: ', error)
    })
}

const initData = function () {
  store.dispatch('userData/openDBChannel').then(
    () => {
      store.dispatch('companyData/openDBChannel', {companyId: store.state.userData.user.company})
      store.dispatch('billsData/openDBChannel', {companyId: store.state.userData.user.company})
    }
  ).catch(console.error)
}
firebase.auth().onAuthStateChanged(
  function (user) {
    if (user) {
      initData()
    } else {
      store.dispatch('companyData/closeDBChannel', {clearModule: true})
      console.log('Auth rejected')
    }
    appInit(user)
  }
)

let appInit = function (user) {
  if (!MyApp.vue) {
    MyApp.vue = new Vue({
      /* eslint-disable no-new */
      el: '#app',
      template: '<App/>',
      components: { App },
      router,
      store,
      data: {
        db: dbinstance,
        env: 'PROD'
      },
      created () {
        this.$nextTick(() => {
          window.componentHandler.upgradeDom()
          window.componentHandler.upgradeAllRegistered()
        })
      },
      methods: {
      }
    })
  }
  if (user) {
    saveToFirestore()
    if (user.photoURL) document.getElementsByClassName('demo-avatar')[0].src = user.photoURL
    if (user.email) document.getElementById('current-email').innerHTML = user.email
  } else {
    document.getElementsByClassName('demo-avatar')[0].src = image
    document.getElementById('current-email').innerHTML = 'hello@example.com'
  }
}

export default dbinstance
export {MyApp}



// WEBPACK FOOTER //
// ./src/main.js